import $ from "jquery";
import axios from "axios";
const List  = require('list.js');

(function () {
    const pagination = {
        init: function () {
            $('body')
                .on('click', '.js-pagination-more', function (e) {
                    e.preventDefault();
                    const $this = $(this),
                        url = $this.attr('href') ? $this.attr('href') : $this.data('url'),
                        items_container = $($this.data('items')),
                        pagination_container = $($this.data('pagination')),
                        pagination_name = $this.data('name') ? $this.data('name') : false,
                        no_history = pagination_name !== false || $this.data('history') === 'false';

                    axios.get(url)
                        .then(response => {
                            if (response.data.status === 'ok') {
                                if (!no_history) {
                                    history.pushState({}, null, url);
                                }
                                const data = pagination_name ? response.data[pagination_name] : response.data;
                                items_container.append(data.items);
                                pagination_container.replaceWith(data.pagination);
                            }
                        });
                });
                // .on('click', 'table.js-pagination + .pagination-wrap a', function (e) {
                //     e.preventDefault();
                //     const $this = $(this),
                //         url = $this.attr('href') ? $this.attr('href') : $this.data('url'),
                //         pagination_container = $this.closest('.pagination-wrap');
                //     let items_container = pagination_container.prev('table.js-pagination');
                //     const pagination_name = items_container.data('name') ? items_container.data('name') : false,
                //         no_history = pagination_name !== false || $this.data('history') === 'false';
                //
                //     items_container = items_container.children('tbody').length ? items_container.children('tbody') : items_container;
                //
                //     axios.get(url)
                //         .then(response => {
                //             if (response.data.status === 'ok') {
                //                 if (!no_history) {
                //                     history.pushState({}, null, url);
                //                 }
                //                 const data = pagination_name ? response.data[pagination_name] : response.data;
                //
                //                 items_container.children(':not(:first-child)').remove();
                //                 items_container.append(data.items);
                //                 pagination_container.replaceWith(data.pagination);
                //             }
                //             for (let key in response.data) {
                //                 if (key === pagination_name) {
                //                     continue;
                //                 }
                //                 $('table.js-pagination[data-name="' + key + '"] + .pagination-wrap')
                //                     .replaceWith(response.data[key].pagination);
                //             }
                //         })
                // });

            $('.js-pagination').each(function() {
                new List($(this).attr('id'), {
                    valueNames: [ 'id', 'date', 'statusName', 'paymentName', 'total' ],
                    listClass: 'table-list',
                    page: 5,
                    pagination: true,
                    updated: function(){
                        $(".table [data-toggle=popover]").popover({
                            html : true,
                            placement: 'left',
                            content: function() {
                                var content = $(this).attr("data-popover-content");
                                return $(content).children(".popover-body").html();
                            },
                        });
                        $('body').on('click', '.popover-body .close', function() {
                            $("[data-toggle=popover]").popover('hide')
                        });
                    }
                });
            });
        }
    }.init();
})();


// WEBPACK FOOTER //
// ./resources/assets/js/modules/pagination.js